// @ vendors
const { APIGet } = require('utilities/APIRequestHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');

const getIntervenersSuccess = (data, contract) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_INTERVENERS_SUCCESS,
    payload: {
        data,
        contract
    }
});

const getIntervenersError = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_INTERVENERS_ERROR,
});

const getIntervenersRequest = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_INTERVENERS_REQUEST,
});

const setContractView = (contract) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_INTERVENERS_VIEW_CONTRACT,
    contract: contract,
});

const cancelViewInterveners = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_VIEW_INTERVENERS_CANCELED
});

const displayModalInterveners = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_VIEW_INTERVENERS_DISPLAY_MODAL
});

const getInterveners = (contractId) => (dispatch, getState) => {
    const brokerCustomWalletInterveners = getState().brokerCustomWalletInterveners;
    const contract = `00${contractId}`;
    const isLoaded = brokerCustomWalletInterveners.getIn(['contractsIntervention', contract, 'isLoaded']);

    if (!isLoaded) {
        const product = contractId.substring(6,9);
        const contractNumber = contractId.substring(9);
        
        const requestData = {
            query: {
                producto: product,
                numeroContrato: contractNumber
            }
        };

        dispatch(getIntervenersRequest());
        dispatch(setContractView(contract));
        return APIGet(dispatch, apiURLBuilder.getURL('hiringInterveners'), requestData)
        .then(response => {
                dispatch(getIntervenersSuccess(response, contract));
        })
        .catch(response => {
            dispatch(getIntervenersError(response.error))
        });
    }
    else {
        dispatch(setContractView(contract));
        dispatch(displayModalInterveners());
    }
};

module.exports = {
    getInterveners,
    cancelViewInterveners
};
